var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-container",class:{ 'active': _vm.showResponseMsg }},[_c('div',{staticClass:"notification-msg"},[_c('p',{class:{'success':_vm.isSuccess, 'failed':!_vm.isSuccess}},[_vm._v(_vm._s(_vm.notificationMsg))])])])}
var staticRenderFns = []

export { render, staticRenderFns }